import { render, staticRenderFns } from "./zhgl.vue?vue&type=template&id=2ba95974&scoped=true&"
import script from "./zhgl.vue?vue&type=script&lang=js&"
export * from "./zhgl.vue?vue&type=script&lang=js&"
import style0 from "./zhgl.vue?vue&type=style&index=0&id=2ba95974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba95974",
  null
  
)

export default component.exports